<!-- <app-admin-header [header]="header" [links]="links" [breadcrumbs]="breadcrumbs" [stats]="stats"></app-admin-header> -->

<div
  class="container mb-4"
  *ngIf="questions.length > 0 && !skelition"
  style="min-height: 60vh"
>
  <div class="d-flex justify-content-end">
    <p-button
      (onClick)="exit(false)"
      [label]="'Exit' | translator"
      icon="pi pi-arrow-left"
      styleClass="my-2"
    ></p-button>
  </div>
  <p-messages [(value)]="messages" [enableService]="false"></p-messages>
  <app-dynamic-form
    [questions]="questions"
    (sendData)="addOU($event)"
    (imgType)="handleImgTypeChange($event)"
  ></app-dynamic-form>
  <div *ngIf="loader" class="spinner-container">
    <div class="spinner"></div>
  </div>
</div>

<!-- skelition   -->
<app-skelitions [hidden]="!skelition" [value]="2"></app-skelitions>

<!-- <app-footer></app-footer> -->
